import { CONTACT_EXTRA_INFO_API } from 'modules/contacts/api/contact-api'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string'
import useSWR from 'swr'
import { ContactId } from '../../types/contact-interface'
import { ContactCoursesApiInterface } from '../types/contact-courses-interface'

interface UseContactCoursesInterface extends SwrPaginationInterface {
  contactId: ContactId
}

export function useContactCourses({ limit, pagination, contactId }: UseContactCoursesInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ContactCoursesApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: contactCourses } = useSWR(() => {
    if (user) {
      return `${CONTACT_EXTRA_INFO_API}/${contactId}/courses/list?${getPaginationQueryString({
        limit,
        pagination,
      })}`
    }
    return null
  }, fetcher)

  return { contactCourses }
}
